const KAKAO_PIXEL_ID = '5016660792027036369';

/**
 * @see https://kakaoad.github.io/kakao-pixel/
 */

export type KakaoPixelEventType = 'pageView' | 'completeRegistration';

const kakaoPixelAgent = {
  isKakaoMomentLoaded() {
    return typeof window !== 'undefined' && 'kakaoPixel' in window;
  },

  recordEvent(eventType: KakaoPixelEventType, tag?: string) {
    if (this.isKakaoMomentLoaded()) {
      switch (eventType) {
        case 'pageView':
          window.kakaoPixel(KAKAO_PIXEL_ID).pageView(tag);
          break;
        case 'completeRegistration':
          window.kakaoPixel(KAKAO_PIXEL_ID).completeRegistration(tag);
          break;
        default:
          break;
      }
    }
  },
};

export default kakaoPixelAgent;
